// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c9923c92","496":"71d6fd68","498":"ef8afcf8","703":"97dcd450"}[chunkId] + ".chunk.js";
};